<template>
  <div>
    <Poptip
      confirm
      class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-editor-list"
      title="你确定删除此条数据吗？"
      @on-ok="operateClick('delete', item)">
      <span
      v-if="type != 'see'"
      class="iv-main-color iv-main-hover-color iv-operate-item iv-pull-left iv-pointer uit-delete-list">删除</span>
    </Poptip>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  inject: {
    operateClick: {
      default () {
        return () => {}
      }
    }
  },
  data () {
    return {
      type: this.$route.query.type
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
